import React, { useState, useEffect, memo } from "react";
import PropTypes from "prop-types";

const Home = memo(
  function Home({ darkMode, setCurrentPage, toggleDarkMode }) {
    const [companyData, setCompanyData] = useState(null);

    useEffect(() => {
      const companyData = JSON.parse(localStorage.getItem("companyData"));
      setCompanyData(companyData);
    }, []);
    return (
      <div className="flex-1 overflow-auto">
        <div
          className={`flex flex-col items-center justify-center h-full ${
            darkMode
              ? "bg-[#1A1918] text-[#C0BFBD]"
              : "bg-[#F5F5F5] text-[#1A1918]"
          }`}
        >
          {/* Company Logo Section */}
          <div className="mb-8">
            {companyData?.logo ? (
              <img
                src={companyData.logo}
                alt={`${companyData.name} logo`}
                className="w-32 h-32 object-contain"
                onError={(e) => {
                  // If logo fails to load, hide the img and show SVG
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
            ) : null}
            <svg
              className={`w-32 h-32 ${companyData?.logo ? "hidden" : ""} ${
                darkMode ? "text-[#C8BCF6]" : "text-[#1A1918]"
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
          </div>

          <h1
            className={`text-4xl font-bold mb-4 ${
              darkMode ? "text-[#C8BCF6]" : "text-[#1A1918]"
            }`}
          >
            Welcome to PaceHRM
          </h1>
          <p className="text-xl mb-8">
            Your comprehensive solution for HR operations
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-6xl">
            {[
              {
                title: "Employee Management",
                description: "Streamline your workforce operations",
              },
              { title: "Time & Attendance", description: "Coming Soon..." },
              { title: "Payroll Processing", description: "Coming Soon..." },
              // { title: "Time & Attendance", description: "Track and manage employee time efficiently" },
              // { title: "Payroll Processing", description: "Simplify your payroll operations" }
            ].map((card, index) => (
              <div
                key={index}
                className={`p-6 rounded-lg ${
                  darkMode ? "bg-[#1F1F22]" : "bg-white"
                } shadow-lg`}
              >
                <h2
                  className={`text-2xl font-semibold mb-2 ${
                    darkMode ? "text-[#C8BCF6]" : "text-[#1A1918]"
                  }`}
                >
                  {card.title}
                </h2>
                <p className={darkMode ? "text-[#C0BFBD]" : "text-[#1A1918]"}>
                  {card.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  },
  (prevProps, nextProps) => {
    // Only re-render if darkMode changes
    return prevProps.darkMode === nextProps.darkMode;
  }
);

Home.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  toggleDarkMode: PropTypes.func.isRequired,
};

export default Home;
